import { EstimateCalculator } from "@/components/EstimateCalculator";

export default function Estimate() {
  return (
    <div className="p-6 md:p-8 max-w-6xl mx-auto">
      <div className="mb-8">
        <p className="text-xs tracking-[0.15em] uppercase font-bold text-primary mb-1">
          Tools
        </p>
        <h1 className="font-display text-3xl font-semibold tracking-tight">Estimate calculator</h1>
        <p className="text-muted-foreground text-sm mt-1">
          Price out a potential cleaning in any city — share a polished quote in seconds.
        </p>
      </div>
      <EstimateCalculator />
    </div>
  );
}
